/**
 * Freshness stamp minutes (TEC navbar redesign Phase 1 "Updated {minutes} min ago", Phase 3 item
 * 3.1's staleness guard). Extracted to its own pure function so IndexStrip.tsx and the static
 * twin's vanilla script (Phase 3 item 3.3, see the copy in web-static's
 * landing-nav-pulse-script.ts) can both apply the same rule without re-deriving it: a pulse
 * older than an hour means the ten-minute cache failed to refresh (should not happen in
 * practice): hide the stamp rather than print a stale, misleading time.
 */
const STALE_AFTER_MINUTES = 60;

export function computeUpdatedMinutesAgo(updatedAtIso: string, now: number = Date.now()): number | null {
  const updatedAtMs = new Date(updatedAtIso).getTime();
  if (Number.isNaN(updatedAtMs)) return null;
  const minutes = Math.max(0, Math.round((now - updatedAtMs) / 60000));
  return minutes >= STALE_AFTER_MINUTES ? null : minutes;
}
